var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"append-to-body":"","title":"自定义地区选择","visible":_vm.dialogVisible,"width":"883px","before-close":()=>{_vm.closeFn(2)}}},[_c('div',{staticClass:"dialog-content"},[_c('city-popver-checkbox',_vm._b({ref:"cityPopverCheckbox",on:{"closeFn":_vm.closeFn}},'city-popver-checkbox',_vm.$attrs,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }